module.exports = __webpack_public_path__ + "img/icon_ai_report_icon_2.4d27d3d3.png";